import { IRREGULAR_OP_COUNT_UPPER_DEFAULT } from '../../common/const/alert-const';
import { IValidation } from '../../common/validation';
import { IGadget } from './gadget';
import { ILegend } from './gadget/basicGadget';
import { INews } from './news';
import { ISelectOption } from './wild';

export interface INewsAlert extends INews {
  alertID: number;
  userName: string;
  targetDate: Date;
  type: number;
  viewStatus: boolean;
  hasNext: boolean;
  graphs: Array<IGadget<any>>;
  texts: string[];
  monthlyReport: IMonthlyReport;
}

export interface IAlertMail {
  accountID: number;
  userID: number;
  alertMailID: number;
  targetDate: Date;
  companyName: string;
  branchName: string;
  sei: string;
  mei: string;
  mail: string;
  alertCount: number;
  // overtimeList: IAlertMailUserDetail[];
  alert36List: IAlertMailUserDetail[];
  intervalList: IAlertMailUserDetail[];
  bannedAppList: IAlertMailUserDetail[];
}

export interface IAlertMailUserDetail {
  alert_user_id: number;
  details: IAlertMailDetail[];
}

export interface IAlertMailDetail {
  userID: number;
  sei: string;
  mei: string;
  type: number;
  value: string;
  count: number;
  typeCount: number;
  settingValue: string;
  alertID: number;
}

export interface IAlertSetting {
  overtimeLimit: string;
  perdayLimit: string;
  permonthLimit: string;
  peryearLimit: string;
  intervalLimit: string;
  irregularOpCountUpper: string;  // 異常操作回数上限。
  startdate: string;
  overtimeChecked: boolean;
  agreement36Checked: boolean;
  perdayChecked: boolean;
  permonthChecked: boolean;
  peryearChecked: boolean;
  intervalChecked: boolean;
  bannedappChecked: boolean;
  irregularOpChecked:boolean
}

export class CAlertSetting implements IAlertSetting {
  public overtimeLimit = '';
  public perdayLimit = '';
  public permonthLimit = '';
  public peryearLimit = '';
  public intervalLimit = '';
  public irregularOpCountUpper = IRREGULAR_OP_COUNT_UPPER_DEFAULT.toString();
  public startdate = '';
  public overtimeChecked = false;
  public agreement36Checked = false;
  public perdayChecked = false;
  public permonthChecked = false;
  public peryearChecked = false;
  public intervalChecked = false;
  public bannedappChecked = false;
  public irregularOpChecked = false;
}

export interface IAlertSettingUnit extends IValidation {
  key: string;
  prefix?: string;
  suffix?: string;
  checked: boolean;
  limit: string;
  type: 'number';
  name: string;
  error: string;
}

export interface IAlert36Setting {
  alert36ID: number;
  jobs: ISelectOption[];
  monthFirst: number;
  yearFirst: string;
  ordinarySettings: IAlertSettingUnit[];
  specialSettings: IAlertSettingUnit[];
  updFlg: boolean;
  delFlg: boolean;
}

export class CAlert36Setting implements IAlert36Setting {
  public alert36ID = 0;
  public jobs = [] as ISelectOption[];
  public monthFirst = 0;
  public yearFirst = '';
  public ordinarySettings = [] as IAlertSettingUnit[];
  public specialSettings = [] as IAlertSettingUnit[];
  public updFlg = false;
  public delFlg = false;
}

export interface IBannedApp {
  bannedAppID: number;
  name: string;
  checked: boolean;
  appChecked: boolean;
  windowChecked: boolean;
  updFlg: boolean;
  delFlg: boolean;
}

export class CBannedApp implements IBannedApp {
  public bannedAppID = 0;
  public name = '';
  public checked = false;
  public appChecked = false;
  public windowChecked = false;
  public updFlg = false;
  public delFlg = false;
}

export interface IAlertDeviceInfo {
  clientID: number;
  acquisitionPeriods?: string;
  userID: number;
  deviceUID: number;
  pcAccountName: string;
  job: number;
  flextime: boolean;
  // minKeyMouseCount: number;
  workstyle_id: number;
  fixedTime: number;
  cutoffDay: number;
  week_first: number;
  month_first?: number;
  year_first: number;
  holiday_date: string;
  japan_break: boolean;
  legal_holiday: number;
}

export interface IAlertQueryData {
  clientID: number;
  acquisitionPeriods: string;
  userList: IAlertDeviceInfo[];
  deviceUIDAry: number[];
  divisionFirst: Date;
  divisionLast: Date;
  startdate?: Date;
  isJapanBreak: boolean;
}

export interface IAlertWorktime {
  user_id: number;
  workstyle_id: number;
  month: string;
  month_first: number;
  year_first: string;
  worktime: number;
}

export interface IAlertCheckResult {
  alert_user_id: number;
  type?: number;
  value: string;
  setting_value?: string;
  worktime?: number;
}

export interface IAlertCheckResultInterval extends IAlertCheckResult {
  end_time: string;
  begin_time: string;
}

export interface IAlertSettingValueJSON {
  perday_limit?: number;
  permonth_limit?: number;
  peryear_limit?: number;
  permonth_count_limit?: number;
  week_first?: number;
  cutoff_day?: number;
  startdate?: number;
  flextime?: boolean;
  legal_holiday?: number;
}

export interface IGraphList {
  text: string;
  url: string;
  legendList: ILegend[];
}

export interface IPdfDownload {
  title: string;
  date: string;
  graphList: IGraphList[]; // グラフ複数表示のため配列に変更
}

export interface IMonthlyReport {
  agreement36List: IAgreemnt36List[];
  intervalList: IIntervalList[];
  bannedAppList: IBannedAppList[];
}

export interface IAgreemnt36List {
  userID: number;
  name: string;
  violations: {
    ordinary_agreed: string;
    ordinary_legal: string;
    special_agreed: string;
    special_legal: string;
    count: string;
  };
  overtimeForOneMonth: {
    ordinary_agreed: string;
    ordinary_legal: string;
    special_agreed: string;
    special_legal: string;
    count: string;
  };
  overtimeForOneYear: {
    ordinary_agreed: string;
    ordinary_legal: string;
    special_agreed: string;
    special_legal: string;
    count: string;
  };
}

export interface IIntervalList {
  userID: number;
  name: string;
  violations: string;
  intervalTime: string;
}

export interface IBannedAppList {
  userID: number;
  name: string;
  violations: string;
  appName: string;
}

export interface IIrregularList {
  userID: number;
  name: string;
  violations: string;
  irregularCount: string;
}
